import React from "react";
import { useState } from "react";

import styles from "./item-stock.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
const ItemStock = ({ stockItem, handleClick }) => {
  return (
    <div
      className={styles["table-item-stock-mobile-container"]}
      onClick={() => {handleClick(stockItem)}}
    >
      <div className={styles["table-item-stock-mobile-col-2"]}>
        <div className={styles["table-item-stock-mobile-header"]}>
          <div className={styles["table-item-stock-mobile-name"]}> {stockItem.date} </div>
          <div className={styles["table-item-stock-mobile-header-separator"]}></div>
          <div className={styles["table-item-stock-mobile-brand"]}>{stockItem.type}</div>
        </div>
        <div className={styles["table-item-stock-mobile-code"]}>{capitalize(i18n.t("order"))}: {stockItem.order}</div>
        <div className={styles["table-item-stock-mobile-stock"]}>
          {stockItem.in !== "" && (
            <span className={styles["table-item-stock-mobile-stock-title"]}>
              {i18n.t("entry.orders")} {stockItem.in}{" "}
            </span>
          )}
          {stockItem.out !== "" && (
            <span className={styles["table-item-stock-mobile-stock-title-out"]}>
              {i18n.t("departure.orders")} {stockItem.out}
            </span>
          )}
        </div>
      </div>
      <div className={styles["table-item-stock-mobile-col-3"]}>
        <div className={styles["table-item-stock-mobile-category"]}>
          <div className={styles["table-item-stock-mobile-category-inner"]}>
            {stockItem.reason}
          </div>
        </div>
        <div className={styles["table-item-stock-mobile-total"]}>
          {i18n.t("balance")} {stockItem.total} {i18n.t("units")}
        </div>
      </div>
    </div>
  );
};

export default ItemStock;
